import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const generateChildrenWrapperClasses = extraClass => classNames(
  'footer-list__additional-children',
  extraClass,
);

const AdditionalChildren = ({ children, extraClass }) => (
  <div className={generateChildrenWrapperClasses(extraClass)}>{children}</div>
);

AdditionalChildren.propTypes = {
  children: PropTypes.node.isRequired,
  extraClass: PropTypes.string,
};


export default AdditionalChildren;
